import * as Yup from 'yup';

export const DELETE_CONFIRMATION_TEXT = 'Permanently delete this label?';

export const DangerousCharacterErrorMessage = (field: string) =>
    `${field} must not start with =, +, -, , or @`;

const getValidationRule = (field: string) =>
    Yup.string()
        .transform((value: string) => value.trim())
        .matches(/^[^=+,\-@]/, DangerousCharacterErrorMessage(field));

export const labelValidationSchema = Yup.object().shape({
    labelName: getValidationRule('Label name').required(
        'Label name is required',
    ),
    labelDescription: getValidationRule('Label description'),
    labelExample: getValidationRule('Label example'),
    variantType: Yup.string().required('Variant type is required'),
});
